<label class="custom-file-upload">
  <input type="file"/>
  {{file ? file.name : placeholder}}
</label>
